import { createFileRoute } from '@tanstack/react-router'

import { KnowledgeListRow } from '@/features/knowledge/components/knowledge-list-row'
import { useCopy } from '@/lib/copy/use-copy'
import { useKnowledge } from '@/lib/copy/use-knowledge'

const LIFE_PATH_NUMBERS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 22, 33] as const

export const Route = createFileRoute('/wiedza/numerologia')({
  component: WiedzaNumerologia,
})

function WiedzaNumerologia() {
  const { shell } = useCopy()
  const { data, isLoading, isError } = useKnowledge()
  const k = shell.knowledge

  return (
    <section className="space-y-4 p-5">
      <a
        href="/wiedza"
        className="font-mono text-hint tracking-[1.3px] text-element-ink-mute uppercase"
      >
        &larr; {k.categoryBackLabel}
      </a>
      <div>
        <h1 className="font-display text-[28px] leading-[1.05] text-element-ink italic">
          {k.sectionNumerology}
        </h1>
        <p className="mt-1 text-hint text-element-ink-dim">
          {k.categoryNumerologyCount} wpisów · {k.categoryNumerologyHint}
        </p>
      </div>

      {isLoading && <p className="text-hint text-element-ink-dim">Ladowanie...</p>}
      {isError && (
        <p className="text-hint text-red-400">
          Nie udalo sie pobrac danych. Odswiez strone.
        </p>
      )}

      {data && (
        <div>
          {LIFE_PATH_NUMBERS.map((n) => {
            const copy = data.knowledge.numerologyLifePath[n]
            if (!copy) return null
            return (
              <KnowledgeListRow
                key={n}
                iconSlot={<span className="font-display text-[18px] italic">{n}</span>}
                title={copy.label}
                body={copy.archetype}
                meta={k.typeTagNumerology}
                href={`/wiedza/numerologia/${n}`}
              />
            )
          })}
        </div>
      )}
    </section>
  )
}
